import { ENV } from "../config/clientConfig";
import axios from "axios";

const platformClient = require("purecloud-platform-client-v2/dist/node/purecloud-platform-client-v2.js");

const objectsApi = new platformClient.ObjectsApi();
const routingApi = new platformClient.RoutingApi();
const usersApi = new platformClient.UsersApi();

const client = platformClient.ApiClient.instance;
export const region = "cac1.pure.cloud";
client.setEnvironment(region);
const { cac1, redirect } = ENV;
const { DEV, ODB, SBC, ICC, SDO, FEC, TIM } = cac1;

let orgName;
let clientId;
let accessToken;

export function setOrg(org) {
  if (org === "DEV") {
    orgName = DEV.orgName;
    clientId = DEV.clientId;
  } else if (org === "ODB") {
    orgName = ODB.orgName;
    clientId = ODB.clientId;
  } else if (org === "SBC") {
    orgName = SBC.orgName;
    clientId = SBC.clientId;
  } else if (org === "ICC") {
    orgName = ICC.orgName;
    clientId = ICC.clientId;
  } else if (org === "SDO") {
    orgName = SDO.orgName;
    clientId = SDO.clientId;
  } else if (org === "FEC") {
    orgName = FEC.orgName;
    clientId = FEC.clientId;
  } else if (org === "TIM") {
    orgName = TIM.orgName;
    clientId = TIM.clientId;
  }
  console.log(orgName);
  return axios
    .post(
      "api/org",
      {
        value: org,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((data) => {
      accessToken = data.data.accessToken;
      return orgName;
    })
    .catch((error) => {
      console.error(error);
    });
}

/**
 * Authenticate the client using Implicit Grant.
 *
 * @returns auth data
 */
export function authenticate(org) {
  setOrg(org);
  return client
    .loginImplicitGrant(clientId, redirect, { state: "state" })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });
}

export function getUser(userId) {
  return usersApi.getUser(userId).then((userData) => {
    // console.log("USER DATA", userData);
    return userData;
  });
}

export function getUserOrgs() {
  let opts = {
    expand: ["organization", "token", "trustors"], // [String] | Which fields, if any, to expand.
    // "integrationPresenceSource": "integrationPresenceSource_example" // String | Get your presence for a given integration. This parameter will only be used when presence is provided as an expand.
  };
  return usersApi.getUsersMe(opts).then((userOrgsData) => {
    // console.log("USER ORGS DATA", userOrgsData);
    return userOrgsData;
  });
}

export function getDivisions() {
  let opts = {
    expand: [],
  };
  return usersApi
    .getUsersMe(opts)
    .then((userData) => {
      let opts = {
        includeDuplicates: false, // Boolean | Include multiple entries with the same role and division but different subjects
      };
      return usersApi.getAuthorizationSubject(userData.id, opts);
    })
    .then((grantsData) => {
      const authorizedDivisions = [
        ...new Set(grantsData.grants.map((grant) => grant.division.id)),
      ];
      if (authorizedDivisions.find((division) => division === "*")) {
        return objectsApi
          .getAuthorizationDivisions(opts)
          .then((divisionsData) => {
            return divisionsData;
          });
      } else {
        let opts = {
          id: authorizedDivisions, // [String] | Include only divisions with the specified ID(s)
        };
        return objectsApi
          .getAuthorizationDivisions(opts)
          .then((divisionsData) => {
            return divisionsData;
          });
      }
    });
}

export function getWrapupCodes(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ascending", // String | Sort order
  // };
  return routingApi.getRoutingWrapupcodes(opts).then((wrapupCodesData) => {
    // console.log("WRAPUPCODES DATA", wrapupCodesData);
    return wrapupCodesData;
  });
}

export function getQueueWrapupCodes(queueId, opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ascending", // String | Sort order
  // };
  return routingApi
    .getRoutingQueueWrapupcodes(queueId, opts)
    .then((queueWrapupCodesData) => {
      // console.log("QUEUE WRAPUPCODES DATA", queueWrapupCodesData);
      return queueWrapupCodesData;
    });
}

export function getQueues(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  // };
  return routingApi.getRoutingQueues(opts).then((queuesData) => {
    // console.log("QUEUES DATA", queuesData);
    return queuesData;
  });
}

// export function postWrapupCodes(body) {
//   let idArr = [];
//   let promises = body.map((b) => {
//     return routingApi.postRoutingWrapupcodes(b).then((data) => {
//       idArr.push({ id: data.id });
//     });
//   });

//   return Promise.all(promises).then(() => {
//     // console.log(idArr);
//     return idArr;
//   });
// }

export function putWrapupcode(wrapupCodeId, body) {
  // return routingApi
  //   .putRoutingWrapupcode(wrapupCodeId, body)
  //   .then((data) => {
  //     // console.log("PUT WRAPUPCODES DATA", data);
  //     return data;
  //   })
  //   .catch((error) => {
  //     console.error("There was an error updating the wrapup code", error);
  //   });

  return axios
    .post(
      "api/routing/putWrapupcode",
      {
        wrapupCodeId,
        body
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
      console.log(res.data.data);
      return res.data.data;
      // setState((prev) => ({ ...prev, valueData: res.data.results }));
    })
    .catch((error) => {
      console.error(error);
      return error
      // setState((prev) => ({ ...prev, error: "Search must have a value." }));
    });
}

export function getQueue(name, selectedDivision) {
  let opts = {
    pageNumber: 1, // Number | Page number
    pageSize: 500, // Number | Page size
    sortOrder: "asc", // String | Note: results are sorted by name.
    name: `*${name}*`, // String | Include only queues with the given name (leading and trailing asterisks allowed)
    // "id": ["id_example"], // [String] | Include only queues with the specified ID(s)
    "divisionId": [selectedDivision], // [String] | Include only queues in the specified division ID(s)
    // "peerId": ["peerId_example"], // [String] | Include only queues with the specified peer ID(s)
    // "cannedResponseLibraryId": "cannedResponseLibraryId_example", // String | Include only queues explicitly associated with the specified canned response library ID
    // "hasPeer": true // Boolean | Include only queues with a peer ID
  };

  return routingApi.getRoutingQueues(opts).then((queueData) => {
    // console.log("QUEUE DATA", queueData);
    return queueData;
  });
}

// export function postWrapupCodesInQueues(queueArr, wrapupCodesArr) {
//   console.log(queueArr);
//   console.log(wrapupCodesArr);
//   let promises = queueArr.map((queue) => {
//     console.log(queue);
//     return routingApi.postRoutingQueueWrapupcodes(queue, wrapupCodesArr);
//   });

//   return Promise.all(promises).then(() => {
//     console.log("Success! Wrapup codes have been added to queues.");
//   });
// }

export function searchWrapupCodes(name) {
  let opts = {
    pageSize: 500, // Number | Page size
    pageNumber: 1, // Number | Page number
    sortBy: "name", // String | Sort order
    name: `*${name}*`, // String | Name of the wrap-up code
  };
  return routingApi
    .getRoutingWrapupcodes(opts)
    .then((searchedWrapupCodesData) => {
      // console.log("WRAPUPCODES DATA", wrapupCodesData);
      return searchedWrapupCodesData;
    });
}

export function removeWrapupCodesFromQueue(queueId, wrapupCodesArr) {
  console.log(queueId);
  console.log(wrapupCodesArr);
  // let promises = wrapupCodesArr.map((wrapupCodeId) => {
  //   return routingApi.deleteRoutingQueueWrapupcode(queueId, wrapupCodeId);
  // });

  // return Promise.all(promises).then(() => {
  //   console.log("Success! Wrapup codes deleted.");
  // });

  return axios
    .post(
      "api/routing/removeWrapupCodesFromQueue",
      {
        queueId,
        wrapupCodesArr: wrapupCodesArr
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
      console.log(res);
      return res.data;
      // setState((prev) => ({ ...prev, valueData: res.data.results }));
    })
    .catch((error) => {
      console.error(error);
      return error
      // setState((prev) => ({ ...prev, error: "Search must have a value." }));
    });
}

export const postWrapupCodes = (wrapupCodesObj) => {
  console.log(wrapupCodesObj);
  return axios
    .post(
      "api/routing/postWrapupCodes",
      {
        wrapupCodesObj,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
      console.log(res);
      return res.data;
      // setState((prev) => ({ ...prev, valueData: res.data.results }));
    })
    .catch((error) => {
      console.error(error);
      throw new Error(error.response.data.details);
      // setState((prev) => ({ ...prev, error: "Search must have a value." }));
    });
};

export function postWrapupCodesInQueues(queueArr, wrapupCodesArr) {
  console.log(queueArr);
  
  console.log(wrapupCodesArr.data);
  return axios
    .post(
      "api/routing/postWrapupCodesInQueues",
      {
        queueArr,
        wrapupCodesArr: wrapupCodesArr.data,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then((res) => {
      console.log(res);
      return res.data;
      // setState((prev) => ({ ...prev, valueData: res.data.results }));
    })
    .catch((error) => {
      console.error(error.response.data.details);
      throw new Error(error.response.data.details);
    });
}
